module.exports = __webpack_public_path__ + "img/nisa.4facae63.svg";